import LayoutHeader from '@/components/layouts/LayoutHeader';
import { Loader } from '@/components/shared/Loader';
import { NeoIntroModal } from '@/features/onboarding/NeoIntroModal';
import { useEntitlement } from '@/hooks/useBillingQueries';
import { useMessageSyncBeacon } from '@/hooks/useMessageSyncBeacon';
import { useUser } from '@/hooks/useUser';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * ProtectedLayout combines authentication check with LayoutHeader.
 * All protected routes should be children of this component.
 */
export default function ProtectedLayout() {
  const memberContextQuery = useUser();
  const entitlementQuery = useEntitlement();
  const location = useLocation();
  useMessageSyncBeacon(Boolean(memberContextQuery.data));

  if (memberContextQuery.isLoading) {
    return <Loader />;
  }

  if (memberContextQuery.isError || !memberContextQuery.data) {
    return <Navigate to="/login" replace />;
  }

  if (entitlementQuery.isLoading) {
    return <Loader />;
  }

  const subscriptionActive = entitlementQuery.data?.subscriptionActive ?? false;
  const onSubscribePage = location.pathname.startsWith('/subscribe');

  if (!subscriptionActive && !onSubscribePage) {
    return <Navigate to="/subscribe" replace />;
  }

  if (subscriptionActive && onSubscribePage) {
    return <Navigate to="/explore" replace />;
  }

  return (
    <>
      <LayoutHeader />
      <NeoIntroModal />
    </>
  );
}
